import MetaComponent from "../../../components/common/MetaComponent";
import Wrapper from "../../../layout/Wrapper";
import ManualPaymentDesk from "../../../screens/callcenters/manual-payment";

const metadata = {
	title: "Manual Payment Recovery",
	description: "Manual review and recovery for pending payment transactions",
};

export default function ManualPaymentPage() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ManualPaymentDesk />
		</Wrapper>
	);
}
